import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { domainSsoEnforcementValidator } from '#validation';
const verifiedDomainConfigUpdateSchema = z.object({
    ssoEnforcementType: domainSsoEnforcementValidator.optional(),
    remapParentDomainEmails: z.boolean().optional(),
});
export class UpdateVerifiedDomainConfigRequestDto extends createZodDto(verifiedDomainConfigUpdateSchema) {
}
